/**
 * @generated SignedSource<<388924e0714842bf787606d38e79c00b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGlobal"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isGlobal",
        "variableName": "isGlobal"
      },
      {
        "kind": "Variable",
        "name": "itemId",
        "variableName": "itemId"
      },
      {
        "kind": "Variable",
        "name": "tagId",
        "variableName": "tagId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "addItemToTag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddItemToTagMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddItemToTagMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "f07bc8dcfd3e044bb0018146fa2a6a45",
    "id": null,
    "metadata": {},
    "name": "AddItemToTagMutation",
    "operationKind": "mutation",
    "text": "mutation AddItemToTagMutation(\n  $tagId: ID!\n  $itemId: ID!\n  $isGlobal: Boolean\n) {\n  addItemToTag(tagId: $tagId, itemId: $itemId, isGlobal: $isGlobal) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "6ff03479f157ccc20cf41c99de3ccca8";

export default node;
